import React from "react"
import styled from "styled-components"

type Props = {
  options: {
    name: string
    value: Props["value"]
    disabled?: boolean
  }[]
} & JSX.IntrinsicElements["select"]

const Component: React.VFC<Props> = (props) => {
  return (
    <label htmlFor={props.id} className={props.className}>
      <select
        name={props.name}
        id={props.id}
        value={props.value ?? ""}
        className={`${props.className}__select`}
        onChange={props.onChange}
        required={props.required}
      >
        {!props.value && (
          <option value="" disabled defaultChecked>
            --選択してください--
          </option>
        )}
        {props.options.map((option) => (
          <option key={String(option.value)} value={option.value} disabled={option.disabled}>
            {option.name}
          </option>
        ))}
      </select>
    </label>
  )
}

const StyledComponent = styled(Component)`
  width: 100%;
  position: relative;

  &__select {
    border: 2px solid #e2e7ec;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #ffffff;
    display: block;
    height: 48px;
    font-size: 1.6rem;
    padding: 10px;
    font-weight: bold;
    width: 100%;
    appearance: none;
    outline: none;
  }

  &:after {
    content: url('/images/arrow-bottom-gray.svg');
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const Select = StyledComponent
